import React from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Setting = () => {

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { language } = useSelector((state) => state.language);

    return (
        <main class="main p-4 relative">
            <div class="flex flex-col">
                <div class="flex flex-wrap items-start gap-y-6 -mx-2">
                    <div class="w-full px-2 flex justify-center items-center h-full">
                        <div className="">
                            <h3 className="text-lg font-extrabold uppercase">Setting Page</h3>
                            <p className="text-gray-400">Comming soon....</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
  )
}

export default Setting